import { SubpageContentBlocks } from "@components/page/SubpageContentBlocks"
import { defineView } from "eddev/views"

export default defineView("_error", (props) => {
  return (
    <>
      <SubpageContentBlocks blocks={props.templateParts?.errorPage?.contentBlocks} />
      <div className="h-10" />
    </>
  )
})
